import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, from, lastValueFrom } from 'rxjs';
import { MsalService } from '@azure/msal-angular';
import { environment } from '@environments/environment';
import { db } from '@database/db';
import { User } from '@entities/user.class';
import { Router } from '@angular/router';
import { switchMap, tap } from 'rxjs/operators';
import { enregistrerRequeteLente, SEUIL_REQUETE_LENTE_MS } from '@services/core/telemetrie';

@Injectable()
export class AzureInterceptor implements HttpInterceptor {
	constructor(private msalService: MsalService,
		private router: Router
	) {}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		try {
			new URL(req.url);
		}
		catch (error) {
			req = req.clone({
				url: environment.baseUrl+req.url,
			});
		}
		const isDomainValid = this.validateDomain(req.url);
		console.log(`Request URL: ${req.url} | Domain valid: ${isDomainValid}`);
		if(isDomainValid) {
			return this.mesurerLenteur(req, from(this.handleRequest(req, next)));
		}
		else {
			return next.handle(req);
		}
	}

	/**
	 * Chronomètre la requête et ne remonte QUE celles qui dépassent le seuil
	 * (cf. enregistrerRequeteLente). Sans effet sur le flux lui-même.
	 */
	private mesurerLenteur(req: HttpRequest<any>, flux: Observable<HttpEvent<any>>): Observable<HttpEvent<any>> {
		const debut = performance.now();
		const signaler = (statut: number | undefined, enErreur: boolean) => {
			const duree = performance.now() - debut;
			if (duree >= SEUIL_REQUETE_LENTE_MS) {
				enregistrerRequeteLente(req.method, req.url, duree, statut, enErreur);
			}
		};
		return flux.pipe(
			tap({
				next: (evenement) => {
					if (evenement instanceof HttpResponse) signaler(evenement.status, false);
				},
				error: (erreur) => signaler(erreur?.status, true),
			})
		);
	}

	private async handleRequest(req: HttpRequest<any>, next: HttpHandler): Promise<HttpEvent<any>> {
		const token = await this.getAzureToken();

		if (token) {
			try {
				const user = await this.getUserData();
				console.log('User data:', user);
				console.log(user?.email, user?.id);
				
				let headers = req.headers.set('Authorization', `Bearer ${token}`);
				
				// Forcer le bypass du service worker pour les requêtes avec headers personnalisés
				headers = headers.set('ngsw-bypass', 'true');
				
				if (user) {
					headers = headers.set('User', JSON.stringify(user));
					// console.log('User header added:', JSON.stringify(user));
				} else {
					// console.warn('No user data available for request');
				}

				const cloned = req.clone({
					headers: headers
				});
				
				return lastValueFrom(next.handle(cloned));
			} catch (error) {
				console.error('Error in handleRequest:', error);
				return lastValueFrom(next.handle(req));
			}
		}
		return lastValueFrom(next.handle(req));
	}

	private async getAzureToken(): Promise<string | null> {
		try {
			await lastValueFrom(this.msalService.acquireTokenSilent({
				scopes: environment.msalConfig.api.scopes,
			}));
		}
		catch (error) {
			this.router.navigate(['/signin']);
			// console.log(error);
		}
		
		// console.log(this.msalService.instance.getActiveAccount());
		return this.msalService.instance.getActiveAccount()?.idToken || null;
	}

	private validateDomain(url: string): boolean {
		const urlDomain = new URL(url).hostname;
		const allowedDomains = environment.allowedDomains;

		// console.log('urlDomain', urlDomain);
		// console.log('allowedDomains', allowedDomains);
		return allowedDomains.some((domain:string) => urlDomain.includes(domain));
	}

	private async getUserData() {
		const user:User|undefined = await db.user.where({ id: this.msalService.instance.getActiveAccount()?.localAccountId }).first();
		return user;
	}
}